import { useDispatch } from 'react-redux';
import React, { useState, useCallback } from 'react';

import * as actions from '../../../redux/actions';

import Radio, { RadioGroup } from '../../Radio';
import Button from '../../Button';
import Modal from '../../Modal';
import Input from '../../Input';
import Label from '../../Label';
import Field from '../../Field';
import ImagePreview from '../../setting-components/ImagePreview';

function MakeTemplate({ site, onClose }) {
    const dispatch = useDispatch();
    const [state, setState] = useState({
        type: '',
        title: '',
        thumbnail: '',
        layout: '',
    });
    const [thumbnail, setThumb] = useState('');
    const handleMakeTemplate = useCallback(() => {
        const temp = {
            ...state,
            thumbnail,
        };
        dispatch(actions.makeTemplate(temp, site.id));
    }, [dispatch, site.id, state, thumbnail]);

    const handleInput = (e) => {
        const { name, checked, value } = e.target;
        setState((state) => ({ ...state, [name]: value }));
    };

    return (
        <Modal
            size="sm"
            onClose={onClose}
            header={
                <div>
                    <strong>Make Template</strong> ({site.id})
                </div>
            }
            footer={
                <div className="spread-between">
                    <Button onClick={onClose} type="link">
                        Cancel
                    </Button>
                    <Button onClick={handleMakeTemplate}>
                        Save as Template
                    </Button>
                </div>
            }
        >
            <form onSubmit={handleMakeTemplate}>
                <Field>
                    <Label htmlFor="templateTitle">Title</Label>
                    <Input
                        value={state.title}
                        name="title"
                        id="templateTitle"
                        onChange={handleInput}
                    />
                </Field>
                <Field>
                    <Label htmlFor="templateUrl">Preview URL</Label>
                    <Input
                        value={state.layout}
                        name="layout"
                        id="templateUrl"
                        onChange={handleInput}
                    />
                </Field>
                <Field>
                    <Label>Template Type:</Label>
                    <br />
                    <RadioGroup
                        name="type"
                        type="own-line"
                        value={state.type}
                        onChange={handleInput}
                    >
                        <Radio value="pro">Pro</Radio>
                        <Radio value="free">Free</Radio>
                    </RadioGroup>
                </Field>
                <Field>
                    <Label>Thumbnail</Label>
                    <ImagePreview
                        accept="image/*"
                        value={thumbnail}
                        onChange={({ value }) => setThumb(value)}
                    />
                </Field>
            </form>
        </Modal>
    );
}

export default MakeTemplate;
